import type { TFunction } from 'i18next';

export type NotificationConfigItem = {
    /** i18n key for the notification name (e.g. "not16.hart.name"). */
    nameKey: string;
    email: boolean;
    sms: boolean;
};

export type NotificationConfigGroup = {
    /** i18n key for the section header (e.g. "Bookings"). */
    titleKey: string;
    items: NotificationConfigItem[];
};

export type NotificationGroup = {
    title: string;
    notifications: { name: string; email: boolean; sms: boolean }[];
};

/**
 * Source of truth for the Manager's "Mi Cuenta → Configuración → Notificaciones"
 * page. Each group is keyed by its i18n title key; each notification is keyed
 * by its i18n name key (`notN.hart.name`). Translation happens at render time
 * via `getNotificationGroups(t)`.
 */
export const NOTIFICATION_CONFIG_GROUPS: NotificationConfigGroup[] = [
    {
        titleKey: 'Bookings',
        items: [
            { nameKey: 'not1.hart.name', email: true, sms: false },
            { nameKey: 'not2.hart.name', email: true, sms: true },
            { nameKey: 'not26.hart.name', email: true, sms: false },
        ],
    },
    {
        titleKey: 'Activities',
        items: [
            { nameKey: 'not3.hart.name', email: true, sms: false },
            { nameKey: 'not4.hart.name', email: true, sms: false },
            { nameKey: 'not27.hart.name', email: true, sms: true },
        ],
    },
    {
        titleKey: 'Events',
        items: [
            { nameKey: 'not10.hart.name', email: true, sms: false },
            { nameKey: 'not11.hart.name', email: true, sms: false },
        ],
    },
    {
        titleKey: 'Games',
        items: [
            { nameKey: 'not45.hart.name', email: true, sms: false },
            { nameKey: 'not47.hart.name', email: true, sms: false },
            { nameKey: 'not48.hart.name', email: true, sms: false },
        ],
    },
    {
        titleKey: 'Payments',
        items: [
            { nameKey: 'not16.hart.name', email: true, sms: true },
            { nameKey: 'not31.hart.name', email: true, sms: false },
            { nameKey: 'not32.hart.name', email: true, sms: false },
            { nameKey: 'not41.hart.name', email: true, sms: true },
        ],
    },
    {
        titleKey: 'Messages',
        items: [
            { nameKey: 'not12.hart.name', email: true, sms: false },
            { nameKey: 'not28.hart.name', email: true, sms: true },
        ],
    },
];

export function getNotificationGroups(t: TFunction): NotificationGroup[] {
    return NOTIFICATION_CONFIG_GROUPS.map((group) => ({
        title: t(group.titleKey),
        notifications: group.items.map((item) => ({
            name: t(item.nameKey),
            email: item.email,
            sms: item.sms,
        })),
    }));
}
